angular.module('mercury.modules.stock.stockonhandreport')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.StockonhandChooser', {
    url: '/stockonhandchooser',
    controller: 'StockStockonhandChooserCtrl',
    templateUrl: 'modules/stock/stockonhandreport/chooser.tpl.html'
  });

  $stateProvider.state('Stock.StockonhandReport', {
    url: '/stockonhandreport/:templateType/:templateId',
    controller: 'StockStockonhandReportCtrl',
    templateUrl: 'modules/stock/stockonhandreport/stockonhandreport.tpl.html'
  });

  $stateProvider.state('Stock.StockonhandReport.Received', {
    url: '/received/:itemId/:startTime/:endTime',
    data: {
      menuLinkState: 'Stock.StocktakeReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupreceived.tpl.html',
        controller: 'StockPurchaseorderPopupreceivedCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StockonhandReport.StockPrice', {
    url: '/price/:itemId/:quantity/:unitName/:unitRatio',
    data: {
      menuLinkState: 'Stock.StockonhandReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktake/pricebox.tpl.html',
        controller: 'StockStocktakePriceboxCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StockonhandReport.CalculatedUsage', {
    url: '/usage/:itemId/:startTime/:endTime/:unitName/:unitRatio',
    data: {
      menuLinkState: 'Stock.StockonhandReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktakereport/calculatedusage.tpl.html',
        controller: 'StockStocktakeReportCalculatedUsageCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  // React Routes
  $stateProvider.state('Stock.StockOnHand', {
    url: '/stock-on-hand?start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl',
  });
}]);
